
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_r2vco_ihl4t_145"
};
  